import { Plus } from 'lucide-react'
import { Column, Row } from 'src/shared/components/Semantic/all'
import { cn } from 'src/shared/components/ui/utils'
import { useLocalization } from 'src/shared/hooks/useLocalization'

export const FAQItem = ({ faq, isOpen, onToggle }) => {
  const { t } = useLocalization()

  return (
    <Column className="border-b border-gray-200 last:border-b-0">
      <button
        type="button"
        onClick={onToggle}
        aria-expanded={isOpen}
        className="w-full py-5 text-left group"
      >
        <Row className="items-start gap-3">
          <Plus
            className={cn(
              'mt-0.5 w-5 h-5 shrink-0 text-amber-500 transition-transform duration-200',
              isOpen && 'rotate-45'
            )}
            strokeWidth={2.5}
            aria-hidden
          />
          <Column className="flex-1 min-w-0 gap-0">
            <span
              className={cn(
                'text-base font-normal text-neutral-700',
                'group-hover:text-neutral-900'
              )}
            >
              {t(faq.question)}
            </span>
            <div
              className={cn(
                'overflow-hidden transition-all duration-200',
                isOpen ? 'max-h-96 pt-3' : 'max-h-0'
              )}
            >
              <p className="text-muted-foreground font-normal">
                {t(faq.answer)}
              </p>
            </div>
          </Column>
        </Row>
      </button>
    </Column>
  )
}
